import { BSidebar } from "bootstrap-vue";
import { forwardSlots } from "../createEgBootstrapProxy";

/**
 * Bootstrap-vue bridge — replace this file with your own EgBSidebar when migrating.
 * Keep hide() if parent uses ref and calls .hide().
 */
export const EgBSidebar = {
  name: "EgBSidebar",
  inheritAttrs: false,
  methods: {
    hide(...args) {
      return this.$refs._egBs?.hide?.(...args);
    },
  },
  render(h) {
    return h(
      BSidebar,
      {
        ref: "_egBs",
        attrs: this.$attrs,
        on: this.$listeners,
        scopedSlots: this.$scopedSlots,
      },
      forwardSlots(this.$slots)
    );
  },
};
